import React from 'react'
import SarasTrans from '../../../../library/notifications/SarasTrans';

const DocTaskStatus = (props)=>{
    const {formObject, viewData} = props;
    // console.log("DocTaskStatus",viewData);
    
    const isHid = formObject.getValueFromKey(viewData, "dataList.isHid", "1");
    const cssStyle ={} //JSON.parse(formObject.getValueFromKey(viewData, "dataList.colCssStyle", "{}"));
    
    if(isHid === "0")
    {
        return(
            <div className="saras-cell">
                <span className="uiDocumentStatus" style={cssStyle}>
                    <SarasTrans value = {viewData.val}/>
                </span>
            </div>
        )
    }
    else{
        return(null)
    }
}

export default DocTaskStatus
